/* Aprils Form Trade Catalogue: navigation, project list, spec sheets and PDF export. */
(function () {
  if (window.AFTC) return;

  var KEY = 'aftc-project-list-v1';
  var memoryList = [];

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function readList() {
    try {
      var raw = window.localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return memoryList; }
  }

  function writeList(list) {
    memoryList = list;
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* storage unavailable */ }
    refreshState();
  }

  function config() {
    var node = document.getElementById('aftc-config');
    if (!node) return { labels: {}, spec: {} };
    try { return JSON.parse(node.textContent); } catch (e) { return { labels: {}, spec: {} }; }
  }

  function label(key, fallback) {
    var c = config();
    return (c.labels && c.labels[key]) || fallback;
  }

  function pieceFrom(el) {
    var card = el.closest('[data-aftc-card]');
    if (!card) return null;
    var node = card.querySelector('script[data-aftc-piece]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  function inList(id) {
    return readList().some(function (item) { return item.id === id; });
  }

  /* ---------- State refresh ---------- */
  function refreshState() {
    var list = readList();
    document.querySelectorAll('[data-aftc-count]').forEach(function (n) {
      n.textContent = list.length;
      n.setAttribute('data-count', list.length);
    });
    document.querySelectorAll('[data-aftc-add]').forEach(function (btn) {
      var piece = pieceFrom(btn);
      if (!piece) return;
      var added = list.some(function (item) { return item.id === piece.id; });
      btn.classList.toggle('is-added', added);
      btn.setAttribute('aria-pressed', added ? 'true' : 'false');
      btn.textContent = added ? (btn.getAttribute('data-label-added') || 'Added') : (btn.getAttribute('data-label-add') || 'Add to project');
    });
    renderDrawer();
    updateFab();
  }

  /* ---------- Floating project list ---------- */
  function fab() { return document.getElementById('aftc-fab'); }

  function updateFab() {
    var el = fab();
    if (!el) return;
    var list = readList();
    var d = drawer();
    var spec = document.getElementById('aftc-spec');
    var blocked = (d && d.classList.contains('is-open')) || (spec && spec.classList.contains('is-open'));
    var show;
    if (el.getAttribute('data-when') === 'always') {
      var bar = document.querySelector('.aftc-toolbar');
      show = bar ? bar.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
    } else {
      show = list.length > 0;
    }
    el.classList.toggle('is-visible', !!show && !blocked);
    var text = el.querySelector('[data-aftc-fab-text]');
    if (text) {
      var one = el.getAttribute('data-text-one') || '1 piece selected';
      var many = el.getAttribute('data-text-many') || '{count} pieces selected';
      text.textContent = list.length === 1 ? one : many.replace('{count}', list.length);
    }
  }

  var fabTicking = false;
  window.addEventListener('scroll', function () {
    if (fabTicking) return;
    fabTicking = true;
    window.requestAnimationFrame(function () { fabTicking = false; updateFab(); });
  }, { passive: true });

  /* ---------- Category navigation ---------- */
  var observer;
  function markActive() {
    var here = window.location.pathname.replace(/\/$/, '');
    document.querySelectorAll('[data-aftc-nav] a').forEach(function (a) {
      var target = (a.getAttribute('href') || '').split('#')[0].replace(/\/$/, '');
      a.classList.toggle('is-active', target !== '' && target === here);
    });
  }

  function buildNav() {
    var navs = document.querySelectorAll('[data-aftc-nav]');
    if (!navs.length) return;
    if (document.querySelector('[data-aftc-nav][data-static]')) { markActive(); return; }
    var cats = Array.prototype.slice.call(document.querySelectorAll('[data-aftc-cat]'));
    var extras = Array.prototype.slice.call(document.querySelectorAll('[data-aftc-navitem]'));
    var items = cats.concat(extras).filter(function (el) { return el.id && el.getAttribute('data-label'); });
    items.sort(function (a, b) {
      return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
    });
    navs.forEach(function (nav) {
      nav.innerHTML = items.map(function (el) {
        return '<a href="#' + esc(el.id) + '" data-target="' + esc(el.id) + '">' + esc(el.getAttribute('data-label')) + '</a>';
      }).join('');
    });
    if (observer) observer.disconnect();
    if (!('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        setActive(entry.target.id);
        var link = document.querySelector('[data-aftc-nav] a[data-target="' + entry.target.id + '"]');
        if (link && link.parentNode.scrollTo) {
          link.parentNode.scrollTo({ left: link.offsetLeft - 40, behavior: 'smooth' });
        }
      });
    }, { rootMargin: '-35% 0px -60% 0px' });
    items.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Category rail and pinned bar ---------- */
  function railItems() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-aftc-cat]'))
      .filter(function (el) { return el.id && el.getAttribute('data-label'); });
  }

  function buildRail() {
    var rail = document.getElementById('aftc-rail');
    if (!rail) return;
    var items = railItems();
    if (!items.length) { rail.innerHTML = ''; return; }
    rail.innerHTML = items.map(function (el) {
      return '<a href="#' + esc(el.id) + '" data-target="' + esc(el.id) + '">' + esc(el.getAttribute('data-label')) + '</a>';
    }).join('');
  }

  function setActive(id) {
    document.querySelectorAll('[data-aftc-nav] a, #aftc-rail a').forEach(function (a) {
      a.classList.toggle('is-active', a.getAttribute('data-target') === id);
    });
  }

  var barTop = null;
  function updatePinned() {
    var bar = document.querySelector('.aftc-toolbar');
    if (!bar || !bar.classList.contains('aftc-toolbar--sticky')) return;
    var spacer = document.querySelector('.aftc-toolbar__spacer');
    if (!spacer) {
      spacer = document.createElement('div');
      spacer.className = 'aftc-toolbar__spacer';
      bar.parentNode.insertBefore(spacer, bar);
    }
    if (barTop === null || !bar.classList.contains('is-pinned')) {
      barTop = bar.getBoundingClientRect().top + window.scrollY;
    }
    var header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height')) || 0;
    var pin = window.scrollY > barTop - header;
    if (pin !== bar.classList.contains('is-pinned')) {
      spacer.style.height = bar.offsetHeight + 'px';
      spacer.classList.toggle('is-active', pin);
      bar.classList.toggle('is-pinned', pin);
    }
  }

  /* The rail stands on its own: it works whether or not the menu bar is sticky. */
  function updateRail() {
    var rail = document.getElementById('aftc-rail');
    if (!rail) return;
    var space = (parseFloat(getComputedStyle(rail).getPropertyValue('--tc-rail-width')) || 150)
      + ((parseFloat(getComputedStyle(rail).getPropertyValue('--tc-rail-offset')) || 22) * 2);
    document.documentElement.style.setProperty('--tc-rail-space', space + 'px');
    document.body.classList.add('aftc-has-rail');
    var items = railItems();
    var first = items[0];
    var last = items[items.length - 1];
    var show = first ? (first.getBoundingClientRect().top < window.innerHeight * 0.6) : false;
    if (last && last.getBoundingClientRect().bottom < 0) show = false;
    rail.classList.toggle('is-visible', show);
  }

  var pinTicking = false;
  window.addEventListener('scroll', function () {
    if (pinTicking) return;
    pinTicking = true;
    window.requestAnimationFrame(function () { pinTicking = false; updatePinned(); updateRail(); });
  }, { passive: true });
  window.addEventListener('resize', function () { barTop = null; updatePinned(); updateRail(); }, { passive: true });

  /* ---------- Drawer ---------- */
  function drawer() { return document.getElementById('aftc-drawer'); }

  function openDrawer() {
    var d = drawer();
    if (!d) return;
    if (d.parentNode !== document.body) document.body.appendChild(d);
    renderDrawer();
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var close = d.querySelector('[data-aftc-close]');
    if (close) close.focus();
    updateFab();
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    updateFab();
  }

  function options(values, selected, otherLabel) {
    var html = '<option value="">' + esc(label('choose', 'Select')) + '</option>';
    (values || []).forEach(function (v) {
      html += '<option' + (v === selected ? ' selected' : '') + '>' + esc(v) + '</option>';
    });
    var other = otherLabel;
    html += '<option' + (selected === other ? ' selected' : '') + '>' + esc(other) + '</option>';
    return html;
  }

  function renderDrawer() {
    var d = drawer();
    if (!d) return;
    var holder = d.querySelector('[data-aftc-items]');
    if (!holder) return;
    var list = readList();
    if (!list.length) {
      holder.innerHTML = '<p class="aftc-drawer__empty">' + esc(label('empty', 'Your project list is empty.')) + '</p>';
      return;
    }
    holder.innerHTML = list.map(function (item, i) {
      return '' +
        '<div class="aftc-item" data-index="' + i + '">' +
          (item.image ? '<img src="' + esc(item.image) + '" alt="" loading="lazy">' : '<span></span>') +
          '<div>' +
            '<p class="aftc-item__name">' + esc(item.name) + '</p>' +
            '<p class="aftc-item__meta">' + esc([item.type, item.code].filter(Boolean).join(' · ')) + '</p>' +
            '<div class="aftc-item__fields">' +
              '<label class="aftc-field"><span>' + esc(label('stone', 'Stone')) + '</span><select data-field="stone">' + options(item.stones, item.stone, label('stone_other', 'Other / to discuss')) + '</select></label>' +
              '<label class="aftc-field"><span>' + esc(label('size', 'Size')) + '</span><select data-field="size">' + options(item.sizes, item.size, label('size_other', 'Custom size')) + '</select></label>' +
              '<label class="aftc-field"><span>' + esc(label('qty', 'Qty')) + '</span><input type="number" min="1" step="1" data-field="qty" value="' + esc(item.qty || 1) + '"></label>' +
              '<label class="aftc-field aftc-field--full"><span>' + esc(label('notes', 'Notes (finish, edge, custom size)')) + '</span><input type="text" data-field="notes" value="' + esc(item.notes || '') + '"></label>' +
            '</div>' +
            '<button type="button" class="aftc-item__remove" data-aftc-remove="' + i + '">' + esc(label('remove', 'Remove')) + '</button>' +
          '</div>' +
        '</div>';
    }).join('');
  }

  function summary() {
    var list = readList();
    if (!list.length) return label('no_pieces', 'No pieces selected.');
    return list.map(function (item, i) {
      var lines = [(i + 1) + '. ' + item.name + (item.code ? ' (' + item.code + ')' : '')];
      var detail = [];
      if (item.stone) detail.push(label('stone', 'Stone') + ': ' + item.stone);
      if (item.size) detail.push(label('size', 'Size') + ': ' + item.size);
      detail.push(label('qty', 'Qty') + ': ' + (item.qty || 1));
      lines.push('   ' + detail.join(' | '));
      if (item.notes) lines.push('   ' + label('notes_short', 'Notes') + ': ' + item.notes);
      if (item.url) lines.push('   ' + item.url);
      return lines.join('\n');
    }).join('\n\n');
  }

  /* ---------- What the buyer has selected ---------- */
  function currentSelection(piece) {
    if (!piece || !piece.variants || !piece.variants.length) return null;
    var form = document.querySelector('main form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;
    var idField = form.querySelector('[name="id"]');
    var id = idField ? parseInt(idField.value, 10) : 0;
    var variant = null;
    piece.variants.forEach(function (v) { if (v.id === id) variant = v; });
    var parts = [];
    if (variant) {
      (variant.options || []).forEach(function (value, i) {
        var name = (piece.option_names || [])[i] || '';
        if (!value || /^default title$/i.test(value)) return;
        parts.push({ label: name, value: value });
      });
    }
    /* line item choices such as Finish, which are not variants */
    form.querySelectorAll('[name^="properties["]').forEach(function (field) {
      if (field.type === 'checkbox' && !field.checked) return;
      if (field.type === 'radio' && !field.checked) return;
      var value = (field.value || '').trim();
      if (!value) return;
      var label = field.getAttribute('name').replace(/^properties\[/, '').replace(/\]$/, '');
      if (/^_/.test(label)) return;
      parts.push({ label: label, value: value });
    });
    return { variant: variant, parts: parts };
  }

  function sizeKey(text) {
    var m = String(text || '').match(/\d+(?:\.\d+)?/);
    return m ? m[0] : '';
  }

  /* ---------- Spec sheet ---------- */
  function specNode() {
    var node = document.getElementById('aftc-spec');
    if (!node) {
      node = document.createElement('div');
      node.id = 'aftc-spec';
      node.className = 'aftc-spec';
      node.setAttribute('role', 'dialog');
      node.setAttribute('aria-modal', 'true');
      document.body.appendChild(node);
    } else if (node.parentNode !== document.body) {
      document.body.appendChild(node);
    }
    return node;
  }

  function openSpec(piece) {
    var c = config();
    var s = c.spec || {};
    var node = specNode();
    var images = (piece.images || []).slice();
    var chosen = currentSelection(piece);
    var chosenSize = '';
    if (chosen) {
      if (chosen.variant && chosen.variant.image) {
        images = [chosen.variant.image].concat(images.filter(function (src) { return src !== chosen.variant.image; }));
      }
      chosen.parts.forEach(function (p) {
        if (/size|length|diameter|dimension/i.test(p.label)) chosenSize = sizeKey(p.value);
      });
    }
    var sizesRows = (piece.dims || []).map(function (d) {
      var mine = chosenSize && (sizeKey(d.label) === chosenSize || sizeKey(d.inches) === chosenSize);
      return '<tr' + (mine ? ' class="is-chosen"' : '') + '><td>' + esc(d.label || s.label_standard || 'Standard') + (mine ? ' <em>' + esc(s.label_chosen || 'specified') + '</em>' : '') + '</td><td>' + esc(d.inches) + (d.cm ? '<small>' + esc(d.cm) + '</small>' : '') + '</td></tr>';
    }).join('');
    sizesRows += (piece.extra || []).map(function (row) {
      return '<tr><td>' + esc(row.label) + '</td><td>' + esc(row.value) + '</td></tr>';
    }).join('');
    var logo = s.logo ? '<img src="' + esc(s.logo) + '" alt="' + esc(s.brand || '') + '">' : '<span class="aftc-spec__brand">' + esc(s.brand || "Aprils Form") + '</span>';
    var sideImgs = images.slice(1, 3).map(function (src) { return '<img src="' + esc(src) + '" alt="">'; }).join('');
    node.innerHTML = '' +
      '<div class="aftc-spec__controls">' +
        '<button type="button" class="aftc-btn aftc-btn--light" data-aftc-spec-print>' + esc(s.print_label || 'Save as PDF') + '</button>' +
        '<button type="button" class="aftc-btn aftc-btn--light aftc-btn--ghost" data-aftc-spec-close>' + esc(s.close_label || 'Close') + '</button>' +
      '</div>' +
      '<article class="aftc-spec__page">' +
        '<header class="aftc-spec__header"><div class="aftc-spec__logo">' + logo + '</div><div class="aftc-spec__doc">' + esc(s.doc_label || 'Specification Sheet') + '</div></header>' +
        '<div class="aftc-spec__title"><div>' +
          (piece.type ? '<div class="aftc-spec__type">' + esc(piece.type) + '</div>' : '') +
          '<h2 class="aftc-spec__name">' + esc(piece.name) + '</h2></div>' +
          (piece.code ? '<div class="aftc-spec__code">' + esc(s.code_label || 'Ref.') + ' ' + esc(piece.code) + '</div>' : '') +
        '</div>' +
        (images.length ? '<div class="aftc-spec__images"' + (sideImgs ? '' : ' style="grid-template-columns:1fr"') + '><img class="aftc-spec__main" src="' + esc(images[0]) + '" alt="">' + (sideImgs ? '<div class="aftc-spec__side">' + sideImgs + '</div>' : '') + '</div>' : '') +
        '<div class="aftc-spec__cols">' +
          '<div>' +
            (chosen && chosen.parts.length ? '<div class="aftc-spec__block aftc-spec__chosen"><h4>' + esc(s.label_specified || 'Specified') + '</h4><p>' + chosen.parts.map(function (part) { return esc(part.label) + ': ' + esc(part.value); }).join('<br>') + '</p></div>' : '') +
            (piece.description ? '<div class="aftc-spec__block"><h4>' + esc(s.label_description || 'Description') + '</h4><p>' + esc(piece.description) + '</p></div>' : '') +
            (piece.stones && piece.stones.length ? '<div class="aftc-spec__block"><h4>' + esc(s.label_stones || 'Customizable in') + '</h4><p>' + esc(piece.stones.join(', ')) + (s.stones_suffix ? ', ' + esc(s.stones_suffix) : '') + '.</p></div>' : '') +
            (piece.notes ? '<div class="aftc-spec__block"><h4>' + esc(s.label_notes || 'Notes') + '</h4><p>' + esc(piece.notes) + '</p></div>' : '') +
            (s.custom_note ? '<div class="aftc-spec__block"><h4>' + esc(s.label_custom || 'Made to order') + '</h4><p>' + esc(s.custom_note) + '</p></div>' : '') +
          '</div>' +
          '<div>' +
            (sizesRows ? '<div class="aftc-spec__block"><h4>' + esc(s.label_dims || 'Standard dimensions') + '</h4><table class="aftc-spec__table">' + sizesRows + '</table></div>' : '') +
            (s.finishes ? '<div class="aftc-spec__block"><h4>' + esc(s.label_finishes || 'Surface finishes') + '</h4><p>' + esc(s.finishes) + '</p></div>' : '') +
            (s.edges ? '<div class="aftc-spec__block"><h4>' + esc(s.label_edges || 'Edge profiles') + '</h4><p>' + esc(s.edges) + '</p></div>' : '') +
          '</div>' +
        '</div>' +
        '<footer class="aftc-spec__footer"><span>' + esc(s.footer || '') + '</span><span>' + (piece.url ? '<a href="' + esc(piece.url) + '">' + esc(piece.url.replace(/^https?:\/\//, '')) + '</a>' : '') + (s.contact ? '<br>' + esc(s.contact) : '') + '</span></footer>' +
      '</article>';
    node.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    updateFab();
  }

  function closeSpec() {
    var node = document.getElementById('aftc-spec');
    if (node) node.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    updateFab();
  }

  /* ---------- Printing ---------- */
  function notice(show) {
    var n = document.querySelector('.aftc-preparing');
    if (!n) {
      n = document.createElement('div');
      n.className = 'aftc-preparing';
      document.body.appendChild(n);
    }
    n.textContent = (config().labels || {}).preparing || 'Preparing your PDF';
    n.classList.toggle('is-visible', show);
  }

  function waitForImages(scope, timeout) {
    var imgs = Array.prototype.slice.call(scope.querySelectorAll('img'));
    var jobs = imgs.map(function (img) {
      img.loading = 'eager';
      if (img.complete && img.naturalWidth) return Promise.resolve();
      return new Promise(function (resolve) {
        img.addEventListener('load', resolve, { once: true });
        img.addEventListener('error', resolve, { once: true });
      });
    });
    return Promise.race([Promise.all(jobs), new Promise(function (r) { setTimeout(r, timeout); })]);
  }

  function printAll() {
    notice(true);
    waitForImages(document.getElementById('main') || document.body, 12000).then(function () {
      notice(false);
      document.body.classList.add('aftc-print-all');
      setTimeout(function () { window.print(); }, 60);
    });
  }

  function printSpec() {
    var node = document.getElementById('aftc-spec');
    if (!node) return;
    waitForImages(node, 6000).then(function () {
      document.body.classList.add('aftc-print-spec');
      setTimeout(function () { window.print(); }, 60);
    });
  }

  window.addEventListener('afterprint', function () {
    document.body.classList.remove('aftc-print-all', 'aftc-print-spec');
  });

  /* ---------- Events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var add = t.closest('[data-aftc-add]');
    if (add) {
      e.preventDefault();
      var piece = pieceFrom(add);
      if (!piece) return;
      var list = readList();
      if (inList(piece.id)) {
        list = list.filter(function (item) { return item.id !== piece.id; });
      } else {
        list.push({
          id: piece.id, name: piece.name, type: piece.type, code: piece.code, url: piece.url,
          image: (piece.images || [])[0] || '', stones: piece.stones || [],
          sizes: (piece.dims || []).map(function (d) { return d.label ? d.label + ' · ' + d.inches : d.inches; }),
          stone: '', size: '', qty: 1, notes: ''
        });
      }
      writeList(list);
      return;
    }
    if (t.closest('[data-aftc-open-list]')) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-aftc-close]')) { e.preventDefault(); closeDrawer(); return; }
    var pdf = t.closest('[data-aftc-pdf]');
    if (pdf) {
      e.preventDefault();
      var url = pdf.getAttribute('data-aftc-pdf-url');
      if (url) { window.open(url + (url.indexOf('?') === -1 ? '?' : '&') + 'print=1', '_blank', 'noopener'); }
      else { printAll(); }
      return;
    }
    var remove = t.closest('[data-aftc-remove]');
    if (remove) {
      var idx = parseInt(remove.getAttribute('data-aftc-remove'), 10);
      var current = readList();
      current.splice(idx, 1);
      writeList(current);
      return;
    }
    var spec = t.closest('[data-aftc-spec]');
    if (spec) {
      e.preventDefault();
      var p = pieceFrom(spec);
      if (p) openSpec(p);
      return;
    }
    if (t.closest('[data-aftc-spec-close]') || t.classList.contains('aftc-spec')) { closeSpec(); return; }
    if (t.closest('[data-aftc-spec-print]')) { printSpec(); return; }
  });

  function saveField(e) {
    var field = e.target.closest('.aftc-item [data-field]');
    if (!field) return;
    var row = field.closest('.aftc-item');
    var list = readList();
    var item = list[parseInt(row.getAttribute('data-index'), 10)];
    if (!item) return;
    item[field.getAttribute('data-field')] = field.value;
    memoryList = list;
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (err) { /* storage unavailable */ }
  }
  document.addEventListener('change', saveField);
  document.addEventListener('input', saveField);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-aftc-form]')) return;
    var active = document.activeElement;
    if (active && active.closest && active.closest('.aftc-item')) active.blur();
    var box = form.querySelector('[data-aftc-summary]');
    if (box) box.value = summary();
    try { window.sessionStorage.setItem('aftc-submitted', '1'); } catch (err) { /* ignore */ }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawer();
    closeSpec();
  });

  function init() {
    buildNav();
    buildRail();
    barTop = null;
    setTimeout(function () { updatePinned(); updateRail(); }, 60);
    /* In the theme editor a re-rendered toolbar brings a fresh drawer; drop the old copy moved to <body>. */
    var fresh = document.querySelector('.aftc-toolbar .aftc-drawer');
    if (fresh) {
      document.querySelectorAll('body > .aftc-drawer').forEach(function (old) { old.remove(); });
    }
    var freshRail = document.querySelector('.aftc-toolbar .aftc-rail');
    if (freshRail) {
      document.querySelectorAll('body > .aftc-rail').forEach(function (old) { old.remove(); });
      document.body.appendChild(freshRail);
    }
    var freshFab = document.querySelector('.aftc-toolbar .aftc-fab');
    if (freshFab) {
      document.querySelectorAll('body > .aftc-fab').forEach(function (old) { old.remove(); });
      document.body.appendChild(freshFab);
    }
    var d = drawer();
    if (d && d.parentNode !== document.body) document.body.appendChild(d);
    var state = d ? d.querySelector('[data-aftc-state]') : null;
    if (state && state.getAttribute('data-posted') === 'true') {
      var submitted = false;
      try { submitted = window.sessionStorage.getItem('aftc-submitted') === '1'; window.sessionStorage.removeItem('aftc-submitted'); } catch (err) { submitted = true; }
      if (submitted) writeList([]);
      openDrawer();
    } else if (state && state.getAttribute('data-errors') === 'true') {
      openDrawer();
    }
    refreshState();
    if (/[?&]print=1/.test(window.location.search)) {
      setTimeout(printAll, 400);
    }
  }

  window.AFTC = { init: init, open: openDrawer, printAll: printAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () { setTimeout(init, 0); });
})();
